import { createContext, PropsWithChildren, useContext, useRef } from 'react'
import {
  IModalLayoutContext,
  ModalLayoutProviderProps,
} from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/Types'
import { Modal } from 'almanac-ui/Modal'
import cx from 'classnames'
import Styles from './ModalLayoutProvider.module.scss'

const ModalLayoutContext = createContext<IModalLayoutContext>({} as IModalLayoutContext)

export const ModalLayoutProvider = ({
  children,
  showFooter = true,
  ...props
}: PropsWithChildren<ModalLayoutProviderProps>) => {
  const submitContainer = useRef(null)
  const titleContainer = useRef(null)
  const backContainer = useRef(null)

  return (
    <ModalLayoutContext.Provider
      value={{
        submitContainer,
        titleContainer,
        backContainer,
      }}
    >
      <Modal.Root {...props}>
        <Modal.Header title={<div ref={titleContainer} />} />
        <Modal.Content className={cx(Styles.content, { [Styles.withFooter]: showFooter })}>{children}</Modal.Content>
        {showFooter && (
          <Modal.Footer>
            <Modal.FooterContent slot="left">
              <div ref={backContainer} />
            </Modal.FooterContent>
            <Modal.FooterContent slot="right">
              <div ref={submitContainer} />
            </Modal.FooterContent>
          </Modal.Footer>
        )}
      </Modal.Root>
    </ModalLayoutContext.Provider>
  )
}

export const useModalLayout = () => useContext(ModalLayoutContext)
